import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./_style.scss";
function Link({ isDisabled, children, href, id, target, look, className, }) {
    return (_jsx("a", { id: id, href: href, target: target, className: classNames("link", className, {
            "--disabled": isDisabled,
        }, 
        // support combinations e.g.: look="secondary small"
        look ? look.split(" ").map((l) => `--${l}`) : undefined), children: children }));
}
export default Link;
